import React from "react";
import * as Styled from "./Style";
import emptyBagIcon from "./../../assets/images/icons/ic_empty_bag.svg";

const CheckoutPageError = (props) => {
  return (
    <Styled.ErrorPageStyle>
      <img src={`${emptyBagIcon}`} />
      <h2>
        {props.checkoutPage == "orderDetails"
          ? "We are sorry."
          : "Error " + props.pageErrorCode}
      </h2>

      {props.checkoutPage == "orderDetails" ? (
        <span>
          <p>
            The website encountered an unexpected error. Please try again later.
          </p>
          <p>We apologise for any inconvenience caused.</p>
          <br />
          <br />
        </span>
      ) : (
        <p>{props.pageErrorMessage}</p>
      )}
      <button
        onClick={props.refreshPage}
        onKeyDown={(e) => {
          e.key === "Enter" && props.refreshPage();
        }}
        className="link-as-btn"
        // tabIndex="0"
      >
        Try again
      </button>
    </Styled.ErrorPageStyle>
  );
};

export default CheckoutPageError;
